module.exports = __webpack_public_path__ + "static/media/Frame-1.65b813b8.svg";